<template>
  <div>
    <div v-if="boletoFormatado">
      <div class="cabecalho">
        <div class="vx-row">
          <div
            class="vx-col sm:w-1/4 w-full mb-2"
            style="display: flex; align-items: center; justify-content: center"
          >
            <img
              :src="dados.dadosEmpresa.logo"
              style="max-height: 120px; max-width: 100%"
            />
          </div>
          <div
            class="vx-col sm:w-3/4 w-full text-center"
            style="padding: 15px; font-weight: 500; justify-content: center"
          >
            <div>BP SEGURADORA S/A</div>
            <small class="mt-3">
              {{ dados.dadosEmpresa.endereco }},
              {{ dados.dadosEmpresa.numero }}
              {{ dados.dadosEmpresa.complemento }},
              {{ dados.dadosEmpresa.bairro }}, {{ dados.dadosEmpresa.cidade }} /
              {{ dados.dadosEmpresa.estado }} - CEP:
              {{ dados.dadosEmpresa.cep }}
              <br />
              <br />
              CNPJ: {{ dados.dadosEmpresa.cpfcnpj }}
            </small>
          </div>
        </div>
      </div>
      <div class="cabecalho p-1" v-if="dados.dadosCobranca.instrucaoInicial">
        <p v-html="dados.dadosCobranca.instrucaoInicial"></p>
      </div>
      <div
        v-if="dados.dadosCobranca.pix && isPixDateValid"
        class="cabecalho p-2 bg-grey"
      >
        <div class="vx-row">
          <div class="vx-col sm:w-2/3 w-full mt-2">
            <h6 class="text-center">PAGUE VIA PIX:</h6>
            <div class="text-center mt-2">
              <b class="">
                Agora você também pode pagar nossos boletos via Pix. Basta abrir
                o APP e escanear o QR Code ou copiar o código abaixo.
                Experimente!
              </b>
            </div>
            <div class="text-center mt-2">
              <b class="">
                {{ dados.dadosCobranca.pix }}
              </b>
            </div>
          </div>
          <div class="vx-col sm:w-1/3 w-full text-center">
            <VueQr :text="dados.dadosCobranca.pix" class="imgPix" />
          </div>
        </div>
      </div>
      <div class="cabecalho mt-4 pb-4 ultimoCabecalho">
        <div class="vx-row">
          <div class="vx-col sm:w-1/5 w-full mt-2">
            <h6>Vencimento:</h6>

            <b>{{ formataData(dados.dadosCobranca.dataVencimento) }}</b>
          </div>
          <div class="vx-col sm:w-1/5 w-full mt-2">
            <h6>Valor:</h6>

            <b>{{ dados.dadosCobranca.valor | currency }}</b>
          </div>
          <div class="vx-col sm:w-3/5 w-full mt-2">
            <h6>Linha DIGITÁVEL:</h6>

            <b>{{ dados.dadosCobranca.linhaDigitavel }}</b>
          </div>
        </div>
      </div>
      <div class="linhaCorte">Corte da linha pontilhada</div>
      <div class="">
        <table class="table">
          <tr>
            <td width="250px">
              <img :src="dados.dadosCobranca.banco.logoBanco" height="35px" />
            </td>
            <td class="linhaDigitavelOverBoleto" valing="bottom">
              <b
                >{{ dados.dadosCobranca.banco.codigoBanco }}-{{
                  dados.dadosCobranca.banco.digitoBanco
                }}</b
              >
              <span>{{ dados.dadosCobranca.linhaDigitavel }}</span>
            </td>
          </tr>
        </table>
        <table class="table table-bordered table-boleto">
          <tr>
            <td colspan="5">
              Local de pagamento
              <b
                >Pagar preferencialmente no
                {{ dados.dadosCobranca.banco.nomeBanco }}
              </b>
            </td>
            <td class="ultimaColuna">
              Vencimento
              <b>{{ formataData(dados.dadosCobranca.dataVencimento) }}</b>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              Cedente
              <b>{{ dados.dadosEmpresa.nome }}</b>
            </td>
            <td class="ultimaColuna">
              Agência/Código cedente<br />
              <b
                >{{ dados.dadosCobranca.banco.agencia }}/{{
                  dados.dadosCobranca.banco.conta
                }}</b
              >
            </td>
          </tr>
          <tr>
            <td>
              Data do documento <br />
              <b>{{ formataData(dados.dadosCobranca.dataEmissao) }}</b>
            </td>
            <td>
              Nº documento<br /><b>{{ dados.dadosCobranca.id }}</b>
            </td>
            <td>Espécie doc.<br /></td>
            <td>Aceite<br /><b>N</b></td>
            <td>
              Data processamento <br />
              <b>{{ formataData(dados.dadosCobranca.dataEmissao) }}</b>
            </td>
            <td class="ultimaColuna">
              Nosso número<br /><b>{{ dados.dadosCobranca.nossoNumero }}</b>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Carteira <b>{{ dados.dadosCobranca.banco.carteira }}</b>
            </td>
            <td>Espécie <b>REAL</b></td>
            <td>Parcela</td>
            <td>Valor {{ dados.dadosCobranca.valor.toFixed(2) }}</td>
            <td class="ultimaColuna">
              (=) Valor documento <br />
              <b>{{ dados.dadosCobranca.valor.toFixed(2) }}</b>
            </td>
          </tr>
          <tr>
            <td colspan="6">
              Instruções (Texto de responsabilidade do cedente)
              <br />
              <br />
              <p v-if="dados.dadosCobranca.instrucao">
                {{ dados.dadosCobranca.instrucao }}
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              Pagador<br />
              <b
                >{{ dados.dadosPagador.nome }} / {{ dados.dadosPagador.cpfcnpj
                }}<br />
                RUA {{ dados.dadosPagador.endereco }},
                {{ dados.dadosPagador.numero }}
                {{ dados.dadosPagador.complemento }},
                {{ dados.dadosPagador.bairro }}<br />
                {{ dados.dadosPagador.cep }} - {{ dados.dadosPagador.cidade }} -
                {{ dados.dadosPagador.estado }}</b
              >
            </td>
            <td class="ultimaColuna">Cód. Baixa</td>
          </tr>
        </table>
        <table class="table" style="font-size: 10px">
          <tr>
            <td width="65%">
              CNPJ Beneficiário: {{ dados.dadosEmpresa.cpfcnpj }}
            </td>
            <td align="right">
              <b>Autenticação mecânica - Ficha de Compensação</b>
            </td>
          </tr>
        </table>
        <div class="barcode text-center">
          <barcode
            v-bind:value="dados.dadosCobranca.barCode"
            format="itf"
            :displayValue="false"
            :width="1.75"
            :height="50"
          >
            Show this if the rendering fails.
          </barcode>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import VueBarcode from 'vue-barcode';
import VueQr from 'vue-qr';

export default {
  name: 'boleto-bemProtege',
  props: ['dadosBoleto'],
  computed: {
    isPixDateValid() {
      if (
        !this.dados.dadosCobranca ||
        !this.dados.dadosCobranca.originalLimitDatePayment
      ) {
        return false;
      }
      return moment
        .utc(this.dados.dadosCobranca.originalLimitDatePayment)
        .startOf('day')
        .isSameOrAfter(moment.utc().startOf('day'));
    },
  },

  data() {
    return {
      boletoFormatado: false,
      dados: {},
    };
  },
  methods: {
    formataData(data) {
      const [date, _] = data.split('T');
      const [ano, mes, dia] = date.split('-');
      const _date = `${dia}/${mes}/${ano}`;

      return _date;
    },
    pegarDados() {
      const dados = this._props.dadosBoleto;

      this.dados = dados.dadosToBoleto;
      this.boletoFormatado = true;
    },
    imprimir(time = 1000) {
      setTimeout(() => {
        window.print();
      }, time);
    },
  },
  mounted() {
    this.pegarDados();
  },
  components: { barcode: VueBarcode, VueQr },
};
</script>
<style lang="scss" scoped>
.table {
  width: 100%;
}
.table-boleto {
  font-size: 10px;
}

.imgPix {
  height: 130px;
}
.bg-grey {
  background-color: #e7e7e7 !important;
}

.cabecalho {
  font-size: 12px;
  border-bottom: 1px solid #e7e7e7;
  h6 {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: bolder;
  }
}
.ultimoCabecalho {
  border-bottom: 0px !important;
}

.linhaCorte {
  border-bottom: 1px dashed #ccc;
  text-align: right;
  padding: 5px;
  font-size: 10px;
  margin: 10px 0;
}
.veiculo {
  width: 33%;
  float: left;
  margin-bottom: 10px;
}
.barcode div svg {
  width: 90% !important;
}
.linhaDigitavelOverBoleto {
  vertical-align: bottom;
  text-align: right;
  font-size: 12px;
  b {
    font-size: 20px;
  }
  span {
    line-height: 30px;
    margin-left: 10px;
  }
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 0px;
  border-color: grey;
  border: 1px solid grey;

  width: 100%;
  tr td {
    padding: 5px;
    border: 1px solid grey;
    border-bottom: 0px;
    border-right: 0px;
  }
  tr:first-child td {
    border-top: 0px;
  }
  tr td:first-child {
    border-left: 0px;
  }
  tr td:last-child {
    border-right: 1px;
  }
}
.tableinfo td {
  width: 1%;
}
</style>
